import { RootState } from "../../../reducers";

export const getCustomDestination = (state: RootState) => state.dropoffLocationSelection?.selectedLocation;
export const getIsCustomAddress = (state: RootState) => state.dropoffLocationSelection?.isCustomAddress || false;